import api from "./axios";
import type { UploadedFile, PaginatedResponse, UploadHistoryEntry } from "@/types";

export const uploadFiles = (formData: FormData) =>
  api
    .post<UploadedFile[]>("/files", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);

export const getFiles = (page = 1, limit = 20) =>
  api
    .get<PaginatedResponse<UploadedFile>>("/files", { params: { page, limit } })
    .then((r) => r.data);

export const getUploadHistory = (page = 1, limit = 50) =>
  api
    .get<PaginatedResponse<UploadHistoryEntry>>("/files/history", { params: { page, limit } })
    .then((r) => r.data);

export const getFile = (id: string) => api.get<UploadedFile>(`/files/${id}`).then((r) => r.data);

export const deleteFile = (id: string) => api.delete(`/files/${id}`).then((r) => r.data);
